var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSrcPortalIconsBlack14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.72 20.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6105",
    "data-name": "Group 6105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7922",
    "data-name": "Path 7922",
    className: "cls-1",
    d: "M18.35,8.39c-.65-.94-.54-1.73.55-2.33-2.04.1-2.28,1.81-.55,2.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7923",
    "data-name": "Path 7923",
    className: "cls-1",
    d: "M22.19,5.88l-.48.1C19.23.76,12.98-1.47,7.75,1.02c-2.16,1.03-3.91,2.77-4.95,4.92l-.28-.06c-1.99-.36-4.02,5.97-.96,7.39.21.1.44.19.66.27,1.69,5.53,7.55,8.64,13.08,6.95,3.3-1.01,5.89-3.58,6.92-6.87.31-.08.62-.2.91-.34,3.06-1.42,1.03-7.75-.96-7.39M11.37,19.11c-3.22-.33-5.98-2.41-7.18-5.41.34-.06.67-.16.99-.29.53-.18.81-.75.64-1.28,0-.01,0-.02-.01-.03,3.08.36,5.45,2.91,5.57,6.01v1ZM9.47,8.31c-.98,1.1-2.38,1.75-3.85,1.81-.06-.04-.13-.07-.2-.1.56-.13.9-.68.77-1.24-.07-.29-.26-.54-.52-.68.43-.14.67-.6.54-1.03-.08-.27-.3-.47-.57-.55l-1.01-.21C6.92,2.11,12.19.55,16.4,2.85c1.48.81,2.69,2.03,3.49,3.51l-.8.17c-.44.12-.7.57-.58,1.01.07.27.28.49.55.57-.5.27-.7.89-.43,1.4.14.27.39.46.68.52-.07.02-.14.06-.21.1-1.49-.04-2.9-.69-3.89-1.81-.73-.8-1.77-1.25-2.86-1.22-1.09-.03-2.14.42-2.87,1.22M13.31,19.09v-.97c.13-3.12,2.51-5.67,5.61-6.02-.2.52.07,1.1.59,1.3.01,0,.02,0,.04.01.25.11.51.19.78.25-1.17,2.96-3.85,5.04-7.01,5.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7924",
    "data-name": "Path 7924",
    className: "cls-1",
    d: "M5.82,6.06c1.09.6,1.19,1.39.55,2.33,1.73-.53,1.49-2.24-.55-2.33"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrcPortalIconsBlack14);
export default __webpack_public_path__ + "static/media/SRC-Portal-Icons-Black-14.60f475d505a2c987b2f3cbc77904cfb0.svg";
export { ForwardRef as ReactComponent };